import PropTypes from 'prop-types'
import React from 'react'
import css from './ActivityIcon.module.css'

const ActivityIcon = ({ event }) => (
  <span className={css.main} data-type={getType(event)} />
)

ActivityIcon.propTypes = {
  event: PropTypes.string.isRequired
}

ActivityIcon.displayName = 'ActivityIcon'

export default ActivityIcon

/**
 * Get icon "type" for the given `event`.
 */

function getType (event) {
  switch (event) {
    case 'Source Added':
    case 'Warehouse Added':
      return 'added'
    case 'Source Disabled':
    case 'Integration Disabled':
    case 'Warehouse Disabled':
      return 'disabled'
    case 'Source Deleted':
    case 'Warehouse Deleted':
      return 'deleted'
    case 'Integration Enabled':
      return 'enabled'
    case 'Integration Credentials Changed':
    case 'Warehouse Credentials Changed':
    case 'Source Credentials Changed':
      return 'credentials'
    case 'Warehouse Run Failed':
    case 'Source Run Failed':
      return 'failed'
    case 'Warehouse Source Success':
      return 'success'
    case 'Workspace Edited':
      return 'edited'
    case 'Billing Plan Changed':
      return 'billing'
  // no default
  }
}



// WEBPACK FOOTER //
// ./components/ActivityIcon.js